<template>
  <div class="page_table_area statistics">
    <!-- 纪念堂 -->
    <div class="table_title">
      <div class="left">纪念堂来源统计：</div>
      <div class="right">
        <div
          :class="`btn_left ${spaceShowTable ? 'selected' : ''}`"
          @click="btnSpaceClick(0)"
        >
          表格
        </div>
        <div
          :class="`btn_right ${spaceShowTable ? '' : 'selected'}`"
          @click="btnSpaceClick(1)"
        >
          图形
        </div>
      </div>
    </div>
    <div class="table_count_zero" v-if="arrSpacesTables.length == 0">
      <img src="@/assets/images/Statistics/table_blank.png" />
      <div>暂无数据</div>
    </div>
    <div
      v-for="(itemTable, indexTable) in arrSpacesTables"
      :key="indexTable"
      v-show="spaceShowTable"
    >
      <div class="space_between_tables" v-if="indexTable > 0"></div>
      <div class="table_area">
        <el-table
          :data="itemTable.content"
          :class="`table_width_${itemTable.cols.length + 1}`"
        >
          <el-table-column
            label=""
            :width="5 * docFontSize"
            class-name="first_column"
          >
          </el-table-column>
          <el-table-column
            label="纪念堂来源"
            :width="17 * docFontSize"
            prop="title"
            class-name="first_column right_border"
          >
          </el-table-column>
          <el-table-column label="" :width="11 * docFontSize">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in itemTable.cols"
            :key="index"
            :label="item.unitShortName"
            :prop="`${item.unitId}`"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      class="echart_area"
      v-show="!spaceShowTable"
      v-for="(itemEchart, indexEchart) in arrSpaceChart"
      :key="indexEchart + 10000"
    >
      <div class="space_between_echart" v-if="indexEchart > 0"></div>
      <div :id="`chart${indexEchart}`" class="echart_obj"></div>
    </div>

    <!-- 产品 -->
    <div class="table_title">
      <div class="left">产品统计：</div>
      <div class="right">
        <div
          :class="`btn_left ${productShowTable ? 'selected' : ''}`"
          @click="btnProductClick(0)"
        >
          表格
        </div>
        <div
          :class="`btn_right ${productShowTable ? '' : 'selected'}`"
          @click="btnProductClick(1)"
        >
          图形
        </div>
      </div>
    </div>
    <div class="table_count_zero" v-if="arrProductTables.length == 0">
      <img src="@/assets/images/Statistics/table_blank.png" />
      <div>暂无数据</div>
    </div>

    <div
      v-for="(itemTable, indexTable) in arrProductTables"
      :key="indexTable + 1000"
      v-show="productShowTable"
    >
      <div class="space_between_tables" v-if="indexTable > 0"></div>
      <div class="table_area">
        <el-table
          :data="itemTable.content"
          :class="`table_width_${itemTable.cols.length + 1}`"
        >
          <el-table-column
            label=""
            :width="5 * docFontSize"
            class-name="first_column"
          >
          </el-table-column>
          <el-table-column
            label="产品名称"
            :width="17 * docFontSize"
            prop="title"
            class-name="first_column right_border"
          >
          </el-table-column>
          <el-table-column label="" :width="11 * docFontSize">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in itemTable.cols"
            :key="index"
            :label="item.productName"
            :prop="`${item.productId}`"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      class="echart_area"
      v-show="!productShowTable"
      v-for="(itemEchart, indexEchart) in arrProductChart"
      :key="indexEchart + 20000"
    >
      <div class="space_between_echart" v-if="indexEchart > 0"></div>
      <div :id="`chart2${indexEchart}`" class="echart_obj"></div>
    </div>
  </div>
</template>

<script>
import mixins from "./Mixins";
import echarts from "echarts";

export default {
  mixins: [mixins],
  data() {
    return {
      singleTableCount: 7,
    };
  },

  computed: {
    arrSpaces() {
      return this.Statistics.arrSpaces;
    },
    arrProducts() {
      return this.Statistics.arrProducts;
    },
    spaceShowTable: {
      get() {
        return this.Statistics.spaceShowTable;
      },
      set(v) {
        this.SETOPTIONS({
          spaceShowTable: v,
        });
      },
    },
    productShowTable: {
      get() {
        return this.Statistics.productShowTable;
      },
      set(v) {
        this.SETOPTIONS({
          productShowTable: v,
        });
      },
    },
    searchingCount() {
      return this.Statistics.searchingCount;
    },
    arrSpaceEchartObj() {
      return this.Statistics.arrSpaceEchartObj;
    },
    arrProductEchartObj() {
      return this.Statistics.arrProductEchartObj;
    },
    arrSpacesTables() {
      let spaces = this.Statistics.arrSpaces;
      let result = this.getTableArr(spaces, 0);
      return result;
    },
    arrProductTables() {
      let products = this.Statistics.arrProducts;
      let result = this.getTableArr(products, 1);
      return result;
    },
    arrSpaceChart() {
      let spaces = this.Statistics.arrSpaces;
      let result = this.getChartArr(spaces, 0);
      return result;
    },
    arrProductChart() {
      let products = this.Statistics.arrProducts;
      let result = this.getChartArr(products, 1);
      return result;
    },

  },
  watch: {
    spaceShowTable(v) {
      if (!v) {
        this.$nextTick(() => {
          if (this.arrSpaceEchartObj.length == 0) {
            this.drawTheChart(0);
          }
        });
      }
    },
    productShowTable(v) {
      if (!v) {
        this.$nextTick(() => {
          if (this.arrProductEchartObj.length == 0) {
            this.drawTheChart(1);
          }
        });
      }
    },
    searchingCount(v) {
      if (v == 0) {
        if (!this.spaceShowTable) {
          this.$nextTick(() => {
            this.drawTheChart(0);
          });
        }
        if (!this.productShowTable) {
          this.$nextTick(() => {
            this.drawTheChart(1);
          });
        }
      }
    },
  },
  methods: {
    // type:0 => 纪念堂 1 => 产品
    getTableArr(data = [], type) {
      let arrResult = [];
      data = JSON.parse(JSON.stringify(data));
      if (type === 0) {
        while (data.length > 0) {
          let i = 0;
          let arr = [];
          let objNewSpace = { title: "新建纪念堂" };
          let objNewCode = { title: "新建访问码浏览数" };
          let totalCount0 = 0;
          let totalCount1 = 0;
          while (i < this.singleTableCount && data.length > 0) {
            let objThis = data[0];
            arr.push(objThis);
            objNewSpace[`${objThis.unitId}`] = objThis.dmCount;
            totalCount0 = totalCount0 + objThis.dmCount;
            objNewCode[`${objThis.unitId}`] = objThis.dmViewCount;
            totalCount1 = totalCount1 + objThis.dmViewCount;
            data.splice(0, 1);
            i = i + 1;
          }
          while( arr.length < this.singleTableCount) {
            arr.push({ unitShortName: "-", unitId: "0" })
            objNewSpace["0"] = "-";
            objNewCode["0"] = "-";
          }
          //总数
          arr.push({ unitShortName: "总数", unitId: "-1" });
          objNewSpace["-1"] = totalCount0;
          objNewCode["-1"] = totalCount1;

          let arrContnet = [];
          arrContnet.push(objNewSpace);
          arrContnet.push(objNewCode);
          arrResult.push({ cols: arr, content: arrContnet });

        }
      } else if (type === 1) {
        while (data.length > 0) {
          let i = 0;
          let arr = [];
          let objPay = { title: "线上支付" };
          let totalCount = 0;
          while (i < this.singleTableCount && data.length > 0) {
            let objThis = data[0];
            arr.push(objThis);
            objPay[`${objThis.productId}`] = objThis.onlineCount;
            totalCount = totalCount + objThis.onlineCount;
            data.splice(0, 1);
            i = i + 1;
          }
          while( arr.length < this.singleTableCount) {
            arr.push({ productName: "-", productId: "0" })
            objPay["0"] = "-";
          }
          //总数
          arr.push({ productName: "总数", productId: "-1" });
          objPay["-1"] = totalCount;

          let arrContnet = [];
          arrContnet.push(JSON.parse(JSON.stringify(objPay)));
          arrResult.push({ cols: arr, content: arrContnet });
        }
      }

      return arrResult;
    },
    getChartArr(data = [], type) {
      let arrResult = [];
      data = JSON.parse(JSON.stringify(data));
      if (type === 0) {
        while (data.length > 0) {
          let i = 0;
          let arrTitle = [];
          let arrValue0 = [];
          let arrValue1 = [];
          let totalCount0 = 0;
          let totalCount1 = 0;
          while (i < this.singleTableCount && data.length > 0) {
            let objThis = data[0];

            totalCount0 = totalCount0 + objThis.dmCount;
            totalCount1 = totalCount1 + objThis.dmViewCount;

            arrTitle.push(objThis.unitShortName);
            arrValue0.push(objThis.dmCount);
            arrValue1.push(objThis.dmViewCount);
            data.splice(0, 1);
            i = i + 1;
          }
          let chartData = this.getEchartOption(
            0,
            ["新建纪念堂", "新建访问码浏览数"],
            arrTitle,
            [arrValue0, arrValue1],
            `新建纪念堂总数：${totalCount0}   新建访问码浏览数：${totalCount1}`
          );
          arrResult.push({ chartData: chartData });
        }
      } else if (type === 1) {
        while (data.length > 0) {
          let i = 0;
          let arrTitle = [];
          let arrValue = [];
          let totalCount = 0;
          while (i < this.singleTableCount && data.length > 0) {
            let objThis = data[0];
            totalCount = totalCount + objThis.onlineCount;
            arrTitle.push(objThis.productName);
            arrValue.push(objThis.onlineCount);
            data.splice(0, 1);
            i = i + 1;
          }
          let chartData = this.getEchartOption(
            1,
            ["线上支付"],
            arrTitle,
            [arrValue],
            `线上支付总数：${totalCount}`
          );
          arrResult.push({ chartData: chartData });
        }
      }
      return arrResult;
    },
    btnSpaceClick(index) {
      if (index == 0 && !this.spaceShowTable) {
        this.spaceShowTable = true;
      } else if (index == 1 && this.spaceShowTable) {
        this.spaceShowTable = false;
      }
    },
    btnProductClick(index) {
      if (index == 0 && !this.productShowTable) {
        this.productShowTable = true;
      } else if (index == 1 && this.productShowTable) {
        this.productShowTable = false;
      }
    },
    getEchartOption(type, topTitles, xTitles, arrData, chartTitle) {
      if (type === 0) {
        let option = {
          title: {
            text: chartTitle,
            padding: 20,
            textStyle: {
              height: 30,
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: topTitles,
            orient: "vertical",
            right: 50,
            top: 20,
            // backgroundColor:"#F7FBFF",
            // borderColor:"#CCD7EA"
          },
          grid: {
            top: 80,
            left: 60,
            right: 30,
          },
          xAxis: [
            {
              type: "category",
              name: "纪念堂来源",
              nameLocation: "end",
              nameGap: -48,
              nameTextStyle: {
                padding: [24, 0, 0, 0],
                color: "#000",
              },
              axisLine: {
                lineStyle: {
                  color: "#CCD7EA",
                },
              },
              axisTick: {
                alignWithLabel: true,
                lineStyle: {
                  width: 9,
                  color: "#CCD7EA",
                  shadowColor: "#CCD7EA",
                  shadowOffsetY: 4,
                },
              },
              axisLabel: {
                margin: 20,
                color: "#000",
                fontSize: 14,
              },
              data: xTitles,
            },
          ],
          yAxis: [
            {
              type: "value",
              splitLine: {
                show: false,
              },
              nameTextStyle: {
                padding: [0, 50, 0, 0],
                color: "#000",
              },
              axisLine: {
                lineStyle: {
                  color: "#CCD7EA",
                },
              },
              axisLabel: {
                color: "#000",
                fontSize: 14,
                formatter: function (value) {
                  if (value < 10000) {
                    return value;
                  } else if (value < 100000000) {
                    return `${value / 10000}万`;
                  } else {
                    return `${value / 100000000}亿`;
                  }
                },
              },
              name: "数量",
            },
          ],
          series: [
            {
              name: topTitles[0],
              type: "bar",
              data: arrData[0],
              barGap: "60%",
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FF7466" },
                  { offset: 1, color: "#FFA366" },
                ]),
              },
              barWidth: 15,
            },
            {
              name: topTitles[1],
              type: "bar",
              data: arrData[1],
              barGap: "60%",
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#4A89F4" },
                  { offset: 1, color: "#66AFFF" },
                ]),
              },
              barWidth: 15,
            },
          ],
        };
        return option;
      } else if (type === 1) {
        let option = {
          title: {
            text: chartTitle,
            padding: 20,
            textStyle: {
              height: 30,
            },
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: topTitles,
            orient: "vertical",
            right: 50,
            top: 20,
          },
          grid: {
            top: 80,
            left: 60,
            right: 30,
          },
          xAxis: [
            {
              type: "category",
              name: "产品名称",
              nameLocation: "end",
              nameGap: -48,
              nameTextStyle: {
                padding: [24, 0, 0, 0],
                color: "#000",
              },
              axisLine: {
                lineStyle: {
                  color: "#CCD7EA",
                },
              },
              axisTick: {
                alignWithLabel: true,
                lineStyle: {
                  width: 9,
                  color: "#CCD7EA",
                  shadowColor: "#CCD7EA",
                  shadowOffsetY: 4,
                },
              },
              axisLabel: {
                margin: 20,
                color: "#000",
                fontSize: 14,
              },
              data: xTitles,
            },
          ],
          yAxis: [
            {
              type: "value",
              splitLine: {
                show: false,
              },
              nameTextStyle: {
                padding: [0, 50, 0, 0],
                color: "#000",
              },
              axisLine: {
                lineStyle: {
                  color: "#CCD7EA",
                },
              },
              axisLabel: {
                color: "#000",
                fontSize: 14,
                formatter: function (value) {
                  if (value < 10000) {
                    return value;
                  } else if (value < 100000000) {
                    return `${value / 10000}万`;
                  } else {
                    return `${value / 100000000}亿`;
                  }
                },
              },
              name: "数量",
            },
          ],
          series: [
            {
              name: topTitles[0],
              type: "bar",
              data: arrData[0],
              barGap: "60%",
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FF7466" },
                  { offset: 1, color: "#FFA366" },
                ]),
              },
              barWidth: 15,
            },
          ],
        };
        return option;
      }
    },
    drawTheChart(type) {
      if (type === 0) {
        for (let i = 0; i < this.arrSpaceChart.length; i++) {
          let objThis = this.arrSpaceChart[i];
          let myChart = echarts.init(document.getElementById(`chart${i}`));
          myChart.setOption(objThis.chartData);
          this.arrSpaceEchartObj.push(myChart);
        }
      } else if (type === 1) {
        for (let i = 0; i < this.arrProductChart.length; i++) {
          let objThis = this.arrProductChart[i];
          let myChart = echarts.init(document.getElementById(`chart2${i}`));
          myChart.setOption(objThis.chartData);
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.page_table_area {
  background-color: #fff;
  position: absolute;
  left: 30px;
  bottom: 0;
  right: 30px;
  top: 182px;

  .space_between_tables {
    height: 20px;
  }

  .table_width_0 {
    width: 0;
  }

  .table_width_1 {
    width: (152 * 0 + 2 + 170 +  110 + 50)px;
  }

  .table_width_2 {
    width: (152 * 1 + 2 + 170 +  110 + 50)px;
  }

  .table_width_3 {
    width: (152 * 2 + 2 + 170 +  110 + 50)px;
  }

  .table_width_4 {
    width: (152 * 3 + 2 + 170 +  110 + 50)px;
  }

  .table_width_5 {
    width: (152 * 4 + 2 + 170 +  110 + 50)px;
  }

  .table_width_6 {
    width: (152 * 5 + 2 + 170 +  110 + 50)px;
  }

  .table_width_7 {
    width: (152 * 6 + 2 + 170 +  110 + 52)px;
  }

  .table_width_8 {
    width: (152 * 7 + 2 + 170 +  110 + 52)px;
    // width: 100%;
  }
  .table_width_9 {
    // width: (152 * 8 + 2 + 170 +  110 + 52)px;
    width: 100%;
  }
  .table_title {
    height: 80px;
    line-height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      color: #040300;
      font-size: 16px;
      margin-left: 30px;
    }

    .right {
      width:200px;
      height: 40px;
      line-height: 40px;
      margin-right: 30px;
      display :flex;
      flex-direction :row;

      .btn_left {
        border-radius:5px 0 0 5px;
      }
      .btn_right {
        border-radius:0 5px 5px 0;
      }
      .btn_left, .btn_right {
        // width: 100px;
        flex:1;
        height: 100%;
        display: inline-block;
        cursor: pointer;
        text-align: center;
        background-color: #fff;
        color: #2C90FF;
        border: #2C90FF 1px solid;
        box-sizing:border-box;

        &.selected {
          background-color: #2C90FF;
          color: #fff;
        }
      }
    }
  }

  .table_count_zero {
    height: 250px;
    margin:0 30px;
    text-align:center;
    border:1px solid #CCD7EA;

    img {
      width:100px;
      height:69px;
      margin-top:66px;
    }
    div {
      margin-top:30px;
      color:#949494;
      font-size:14px
    }
  }

  .echart_area {
    margin-left: 30px;
    margin-right: 30px;

    .total {
      float: right;
      width: 200px;
      height: 70px;
      background-color: #F7FBFF;
    }

    .echart_obj {
      // width:1550px;
      height: 310px;
      border: 1px solid #ccd7ea;
    }

    .space_between_echart {
      height: 20px;
    }
  }
}
</style>
<style lang="stylus">
.page_table_area.statistics {
      padding-bottom:100px;

  .first_column {
    background: #F7FAFF;
    font-weight: 500;


    &.right_border {
      border-right: 1px solid #ccd7ea;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/Statistics/components/statisticsTable.vue